import { codeSplit, Controller, FetchOptions, Result, AnalyticsStore } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

import { UiStore, ProgramStore } from 'stores';

// util
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

export class ProductsController implements Controller {
  public pageId = pageNames.products;
  public path = '/:localeName/products';
  public routeName = 'products';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "products-page" */ '../views/products-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request } = options;

    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');
    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Products' }) as Promise<PageData>;
  }
}
